import React from 'react';
import './css/App.css';

// SEO
import SEO from '../../components/seo/SEO';
import { softwareApplicationJsonLd } from '../../components/seo/structuredData';

// COMPONENTS
import Navbar from '../../components/navbar/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import Doubts from './components/Doubts/Doubts';
import About from './components/About';
import ExplainFeatures from './components/ExplainFeatures';
import Footer from '../../components/footer/Footer';
import WhatsappButton from './components/WhatsappButton';
import PainList from './components/PainList';
import Testimonials from './components/Testimonials';
// import Pricing from './components/Pricing';
// import CMV from './components/CMV';
// import AI from './components/AI';
import CTA from './components/CTA';
import MobileExplain from './components/MobileExplain';
import TestButton from './components/TestButton';


function Home() {

  return (
    <div className="App">
      <SEO
        title="SofChef | Sistema de gestão para restaurantes e bares"
        description="Sistema de gestão para restaurantes e bares com cardápio digital, controle de mesas, caixa e emissão fiscal. Teste grátis o SofChef."
        path="/"
        jsonLd={softwareApplicationJsonLd}
      />
      <Navbar />
      <Hero />
      <Features />
      <Stats />
      <MobileExplain/>
      <PainList/>
      {/* <Testimonials/> */}
      {/* <AI/> */}
      {/* <CMV/> */}
      <About />
      <ExplainFeatures />
      {/* <Pricing/> */}
      <Doubts />
      <CTA/>
      <Footer />
      <WhatsappButton />
      <TestButton />
    </div>
  );
}

export default Home;
